import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { UIRouterModule } from '@uirouter/angular';

import { PlatonSharedModule } from '../shared';

import {
    adminState,
    AuditsComponent,
    TrainingPlanningAgencyComponent,
    TrainingPlanningAgencyDetailComponent,
    AuditsService,
    auditState,
    configState,
    docsState,
    healthState,
    JhiConfigurationComponent,
    JhiConfigurationService,
    JhiDocsComponent,
    JhiHealthCheckComponent,
    JhiHealthModalComponent,
    JhiHealthService,
    JhiMetricsMonitoringComponent,
    JhiMetricsMonitoringModalComponent,
    JhiMetricsService,
    LogsComponent,
    LogsService,
    logsState,
    metricsState,
} from './';

let ADMIN_STATES = [
    adminState,
    auditState,
    configState,
    docsState,
    healthState,
    logsState,
    metricsState,
];

@NgModule({
    imports: [
        PlatonSharedModule,
        UIRouterModule.forChild({ states: ADMIN_STATES }),
    ],
    declarations: [
        AuditsComponent,
        LogsComponent,
        TrainingPlanningAgencyComponent,
        TrainingPlanningAgencyDetailComponent,
        JhiConfigurationComponent,
        JhiHealthCheckComponent,
        JhiHealthModalComponent,
        JhiDocsComponent,
        JhiMetricsMonitoringComponent,
        JhiMetricsMonitoringModalComponent,
    ],
    entryComponents: [
        JhiHealthModalComponent,
        JhiMetricsMonitoringModalComponent,
    ],
    providers: [
        AuditsService,
        JhiConfigurationService,
        JhiHealthService,
        JhiMetricsService,
        LogsService,
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class PlatonAdminModule {}



// WEBPACK FOOTER //
// ./src/app/admin/admin.module.ts